import { settings } from '@/settings';

export const BROKER_RETURN_PREFIXES = [
  '/api/hosting/authorize?',
  '/api/oauth/authorize/?',
];

const hasControlCharacter = (value: string) =>
  Array.from(value).some((char) => {
    const code = char.charCodeAt(0);
    return code <= 0x1f || code === 0x7f;
  });

export const brokerReturnUrl = (
  next: string | null | undefined,
): string | null => {
  if (typeof next !== 'string') return null;
  if (!BROKER_RETURN_PREFIXES.some((prefix) => next.startsWith(prefix)))
    return null;
  if (next.includes('//') || next.includes('\\')) return null;
  if (hasControlCharacter(next)) return null;
  return `${settings.BASE_API_ORIGIN}${next}`;
};

export const goToBrokerUrl = (url: string) => window.location.assign(url);
